import React from "react"
import autobind from "class-autobind"
import { browserHistory } from "react-router"
import { Menu, MenuItem, Avatar, IconButton, FontIcon } from "material-ui"
import HierarchySettingsStore from "../../stores/HierarchySettingsStore"
import AccountStore from "../../stores/AccountStore"
import HierarchyIcon from "material-ui/svg-icons/action/supervisor-account"
import RecordsIcon from "material-ui/svg-icons/av/library-books"
import EmployeesIcon from "material-ui/svg-icons/social/person"
import ClientIcon from "material-ui/svg-icons/action/perm-contact-calendar"
import GearIcon from "material-ui/svg-icons/action/settings"
import HardwareComputer from "material-ui/svg-icons/hardware/computer"
import ImageTimer from "material-ui/svg-icons/image/timer"
import BuildIcon from "material-ui/svg-icons/action/build"
import SmartPhone from "material-ui/svg-icons/hardware/smartphone"
import AirPlane from "material-ui/svg-icons/device/airplanemode-active"
import _ from "lodash"
import strings from "../../localization/strings"
import * as hierarchyNavItemsHelper from "../../helpers/hierarchyNavItemsHelper"
import { IUserDocument, ELoggedInUserType } from "../../models"
import * as permissionHelper from "../../helpers/permissionHelper"
import AuthenticationStore from "../../stores/AuthenticationStore"
import AppStateStore from "../../stores/AppStateStore"
import { checkJobFieldAvailable } from "../../helpers/jobHelper"

const items = {
    dashboard: [{ label: "Dashboard", link: "/dashboard", locked: false }],
    payroll: [{ label: "Payroll", link: "/payroll", locked: false }],
    timecard: [{ label: "Timecards", link: "/timecards", locked: false }],
    leaveTracking: [{ label: "Leave Tracking", link: "/leave-tracking", locked: false }],
    clients: [{ label: "Clients", link: "/clients", locked: false }],
    jobs: [{ label: "Jobs", link: "/jobs", locked: false }],
    equipment: [{ label: "Equipment", link: "/equipment", locked: false }],
    records: [{ label: "Records", link: "/records", locked: false }],
    devices: [{ label: "Devices", link: "/toplevel-devices", locked: false }],
    schedules: AppStateStore.hideSchedulePatternTemplate ?
		[
              { label: strings.Posted_Schedules, link: "/schedule/posted_schedules", locked: false },
              { label: strings.Schedule_Planners, link: "/schedule/schedule_planners", locked: false },
              { label: strings.Master_Schedules, link: "/schedule/master_schedules", locked: false },
              { label: strings.Schedule_Templates, link: "/schedule/schedule_templates", locked: false },
              { label: strings.Shift_Templates, link: "/schedule/shift_templates", locked: false }
          ] :
		[
              { label: strings.Posted_Schedules, link: "/schedule/posted_schedules", locked: false },
              { label: strings.Schedule_Planners, link: "/schedule/schedule_planners", locked: false },
              { label: strings.Master_Schedules, link: "/schedule/master_schedules", locked: false },
              { label: strings.Schedule_Templates, link: "/schedule/schedule_templates", locked: false },
              { label: strings.Pattern_Templates, link: "/schedule/pattern_templates", locked: false },
              { label: strings.Shift_Templates, link: "/schedule/shift_templates", locked: false }
          ],
    employees: [{ label: "Employees", link: "/employees", locked: false }],
    hierarchy: [
        { label: "Details", link: "/hierarchy/details", locked: false },
        { label: "Children", link: "/hierarchy/children", locked: false },
        { label: "Users", link: "/hierarchy/users", locked: false },
        { label: "Employees", link: "/hierarchy/employees", locked: false },
        { label: "Positions", link: "/hierarchy/positions", locked: false },
        { label: "Location", link: "/hierarchy/location", locked: false },
        { label: "Records", link: "/hierarchy/records", locked: false },
        { label: "Devices", link: "/hierarchy/devices", locked: false },
        { label: "Settings", link: "/hierarchy/settings", locked: false }
    ],
    account: [
        { label: "Users", link: "/account/<%=cookieAccountId%>/Users", locked: false },
        { label: "HierarchyDefinitions", link: "/account/<%=cookieAccountId%>/HierarchyDefinitions", locked: false },
        { label: "Positions", link: "/account/<%=cookieAccountId%>/Positions", locked: false },
        { label: "Settings", link: "/account/<%=cookieAccountId%>/Settings", locked: false },
        { label: "Billing", link: "/account/<%=cookieAccountId%>/Billing", locked: false }
    ]
}
interface IProps {
    isAdmin: boolean
    loggedInUser: IUserDocument
    cookieAccountId: string
    showTimecards: boolean
    showEquipment: boolean
    showEmployees: boolean
    showRecords: boolean
    showTopLeveDevices: boolean
    showPayroll: boolean
    showLeaveTracking: boolean
    showSchedule: boolean
    loggedInUserType: ELoggedInUserType
    selectedItem: string
    selectedHierarchy: boolean
    showClients: boolean
    showJobs: boolean
    showHierarchy: boolean
    nestedUserMenuItems: object
    onProfileClick(): void
    onLogoutClick(): void
}
interface IState {
    hierarchySubMenuItems: string[]
}

export default class CollapsedLeftNav extends React.Component<IProps, IState> {
    constructor(props) {
        super(props)
        this.state = {
            hierarchySubMenuItems: [],
        }
        autobind(this)
    }

    componentDidMount() {
        HierarchySettingsStore.on("global_change", this.getHierarchySubMenuItems)
        this.getHierarchySubMenuItems()
    }

    componentWillUnmount() {
        HierarchySettingsStore.removeListener("global_change", this.getHierarchySubMenuItems)
    }

    getHierarchySubMenuItems() {
        const { selectedItem, selectedHierarchy } = this.props
        const isRoot = HierarchySettingsStore.getGlobalLevelItemFilterId() ? false : true
        const hierarchySubMenuItems = hierarchyNavItemsHelper.getHierarchySubMenuItems(
            isRoot,
            AccountStore.getCurrentAccountSettings().HierarchySettings.DisableHierarchyItemsForAccountUserUnlessAssigned,
            AccountStore.getCurrentAccountSettings().HierarchySettings.DisableHierarchyItemsForEmployeeUnlessAssigned,
            selectedItem,
            selectedHierarchy
        )
        this.setState({ hierarchySubMenuItems })
    }

    render() {
        const isAdmin = this.props.isAdmin
        const loggedInUser = this.props.loggedInUser
        const cookieAccountId = this.props.cookieAccountId

        const menuTextStyle = { color: AppStateStore.getFrontEndSettings().UISettings.MenuTextColor, textDecoration: "none", padding: 0 }

        const collapsedStyle = {
            backgroundColor: AppStateStore.getFrontEndSettings().UISettings.MenuBackgroundColor,
            menuTextStyle,
            marginTop: -7
        }
        const collapsedStyleLast = {
            backgroundColor: AppStateStore.getFrontEndSettings().UISettings.MenuBackgroundColor,
            menuTextStyle,
            marginTop: -8,
            marginBottom: -9
        }

        const hierarchyMenuItems = []
        this.state.hierarchySubMenuItems.forEach(menuItem => {
            hierarchyMenuItems.push(items.hierarchy.find(item => item.label.toLowerCase() === menuItem))
        })

        if (!AccountStore.getAccrualsTimeoffEnabled()) {
            items.leaveTracking = [{ label: "Leave Tracking", link: "/leave-tracking", locked: true }]
        }
        if (!AccountStore.getScheduleEnabled()) {
            items.schedules = [{ label: strings.Schedule, link: "/schedule/posted_schedules", locked: true }]
        }
		else {
            if (!permissionHelper.hasPermission(AuthenticationStore.Permissions.Schedule.ViewAccountSchedule)) {
                items.schedules = items.schedules.filter((item) => ![strings.Shift_Templates, strings.Pattern_Templates, strings.Schedule_Templates].includes(item.label))
            }
            if (!permissionHelper.hasPermission(AuthenticationStore.Permissions.Schedule.ViewSchedule)) {
                items.schedules = items.schedules.filter((item) => ![strings.Schedule_Planners, strings.Posted_Schedules, strings.Master_Schedules].includes(item.label))
            }
        }

        const menus = [
            {
                icon: <HardwareComputer style={{ fill: AppStateStore.getFrontEndSettings().UISettings.MenuTextColor }} />,
                items: items.dashboard,
                label: strings.Dashboard
            },
            {
                icon: <FontIcon className={"fa fa-money"} color={AppStateStore.getFrontEndSettings().UISettings.MenuTextColor} />,
                items: items.payroll,
                label: strings.Payroll
            },
            {
                icon: <ImageTimer style={{ fill: AppStateStore.getFrontEndSettings().UISettings.MenuTextColor }} />,
                items: items.timecard,
                label: strings.Timecards
            },
            {
                icon: <AirPlane style={{ fill: AppStateStore.getFrontEndSettings().UISettings.MenuTextColor }} />,
                items: items.leaveTracking,
                label: strings.Leave_Tracking
            },
            {
                icon: <ClientIcon style={{ fill: AppStateStore.getFrontEndSettings().UISettings.MenuTextColor }} />,
                items: items.clients,
                label: strings.Clients
            },
            {
                icon: <FontIcon className="fa fa-shopping-bag" color={AppStateStore.getFrontEndSettings().UISettings.MenuTextColor} style={{ fontSize: 22 }} />,
                items: items.jobs,
                label: checkJobFieldAvailable("plural") ? AccountStore.getCurrentAccountSettings().CustomFieldSettings.JobFieldLabels.PluralJobLabel : strings.Jobs
            },
            {
                icon: <FontIcon className="fa fa-calendar" color={AppStateStore.getFrontEndSettings().UISettings.MenuTextColor} style={{ fontSize: 22 }} />,
                items: items.schedules,
                label: strings.Schedules
            },
            {
                icon: <EmployeesIcon style={{ fill: AppStateStore.getFrontEndSettings().UISettings.MenuTextColor }} />,
                items: items.employees,
                label: strings.Employees
            },
            {
                icon: <BuildIcon style={{ fill: AppStateStore.getFrontEndSettings().UISettings.MenuTextColor }} />,
                items: items.equipment,
                label: strings.Equipment
            },
            {
                icon: <RecordsIcon style={{ fill: AppStateStore.getFrontEndSettings().UISettings.MenuTextColor }} />,
                items: items.records,
                label: strings.Records
            },
            {
                icon: <SmartPhone style={{ fill: AppStateStore.getFrontEndSettings().UISettings.MenuTextColor }} />,
                items: items.devices,
                label: strings.Devices
            },
            {
                icon: <HierarchyIcon style={{ fill: AppStateStore.getFrontEndSettings().UISettings.MenuTextColor }} />,
                items: hierarchyMenuItems,
                label: strings.Hierarchy
            },
            {
                icon: <GearIcon style={{ fill: AppStateStore.getFrontEndSettings().UISettings.MenuTextColor }} />,
                items: items.account.filter(i => AccountStore.getHideBilling() ? i.label !== "Billing" : true).map(i => {
                        return {
                            label: i.label,
                            link: _.template(i.link)({ cookieAccountId })
                        }
                    }),
                label: strings.Account
            }
        ]

        if (!this.props.showEmployees) {
            const employeesMenuItem = menus.find((item) => item.label === strings.Employees)
            menus.splice(menus.indexOf(employeesMenuItem), 1)
        }

        if (!this.props.showRecords) {
            const recordsMenuItem = menus.find((item) => item.label === strings.Records)
            menus.splice(menus.indexOf(recordsMenuItem), 1)
        }

        if (!this.props.showTopLeveDevices) {
            const devicesMenuItem = menus.find((item) => item.label === strings.Devices)
            menus.splice(menus.indexOf(devicesMenuItem), 1)
        }

        if (!this.props.showTimecards) {
            const timecardsMenuItem = menus.find((item) => item.label === strings.Timecards)
            menus.splice(menus.indexOf(timecardsMenuItem), 1)
        }

        if (!isAdmin) {
            const accountMenuItem = menus.find((item) => item.label === strings.Account)
            menus.splice(menus.indexOf(accountMenuItem), 1)
        }

        if (!this.props.showEquipment) {
            const equipmentMenuItem = menus.find((item) => item.label === strings.Equipment)
            menus.splice(menus.indexOf(equipmentMenuItem), 1)
        }

        if (!this.props.showPayroll) {
            const payrollMenuItem = menus.find((item) => item.label === strings.Payroll)
            menus.splice(menus.indexOf(payrollMenuItem), 1)
        }

        if (!this.props.showLeaveTracking) {
            const leaveTrackingMenuItem = menus.find((item) => item.label === strings.Leave_Tracking)
            menus.splice(menus.indexOf(leaveTrackingMenuItem), 1)
        }

        if (!this.props.showSchedule) {
            const scheduleMenuItem = menus.find((item) => item.label === strings.Schedules)
            menus.splice(menus.indexOf(scheduleMenuItem), 1)
        }

        if (!this.props.showClients) {
            const clientMenuItem = menus.find((item) => item.label === strings.Clients)
            menus.splice(menus.indexOf(clientMenuItem), 1)
        }

        if (!this.props.showJobs) {
            const jobMenuItem = menus.find((item) => item.label === strings.Jobs)
            menus.splice(menus.indexOf(jobMenuItem), 1)
        }

        if (!this.props.showHierarchy) {
            const hierarchyMenuItem = menus.find((item) => item.label === strings.Hierarchy)
            menus.splice(menus.indexOf(hierarchyMenuItem), 1)
        }

        return (
            <div className="collapsed-nav-container">
                <div className="side-nav-spacer-collapsed" />
                <div className="CollapsedLeftNav left-nav-collapsed" style={{ zIndex: 1000, overflowX: "hidden", overflowY: "auto", backgroundColor: AppStateStore.getFrontEndSettings().UISettings.MenuBackgroundColor }}>
                    <div
                        style={{
                            marginLeft: -9,
                            backgroundColor: AppStateStore.getFrontEndSettings().UISettings.MenuSelectedBackgroundColor,
                            paddingBottom: 5
                        }}
                    >
                        <MenuItem
                            key={"wrapper"}
                            style={{ height: 80, backgroundColor: AppStateStore.getFrontEndSettings().UISettings.MenuSelectedBackgroundColor }}
                            leftIcon={
                                <IconButton>
                                    {loggedInUser.ProfileImageS3Url ?
                                        <Avatar src={loggedInUser.ProfileImageS3Url} /> :
                                        <Avatar>{loggedInUser.FirstName[0].toUpperCase() + loggedInUser.LastName[0].toUpperCase()}</Avatar>
                                    }
                                </IconButton>
                            }
                            menuItems={this.props.nestedUserMenuItems}
                        />
                    </div>
                    {this.props.loggedInUserType !== ELoggedInUserType.Employee &&
                        <div style={{ paddingBottom: 50 }}>
                            <Menu
								autoWidth={false}
								width={70}
								listStyle={{ maxWidth: 70, paddingLeft: 10 }}
								menuItemStyle={{ marginTop: 20}}
							>
                                {menus.map((menu, index) =>
                                    <MenuItem
                                        key={index}
                                        leftIcon={menu.icon}
                                        menuItems={menu.items.map((item, index1) => {
                                            const itemStyle = index1 === item.length - 1 ? collapsedStyle : collapsedStyleLast
                                            return (
                                                <div className="menu-item-wrapper">
                                                    <MenuItem
                                                        key={item.label}
                                                        style={itemStyle}
                                                        primaryText={item.label}
                                                        onClick={() => browserHistory.push(item.link)}
                                                        rightIcon={item.locked ?
                                                                <img src="https://findd-prod-assets.s3.us-west-2.amazonaws.com/web/paywall-lock.png" style={{ width: 15, objectFit: "contain" }} /> :
															null
                                                        }
                                                    />
                                                </div>
                                            )
                                        })}
                                    />
                                )}
                            </Menu>
                        </div>
                    }
                </div>
            </div>
        )
    }
}
